module.exports = __webpack_public_path__ + "img/hero.4d2cd041.jpg";